import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Switch } from '../../../components/ui/switch';
import { Settings, AlertCircle, AlertTriangle } from 'lucide-react';

export const SettingsDialog = ({ 
  open, 
  onOpenChange, 
  escalationForm, 
  setEscalationForm, 
  onSaveSettings,
  onCheckEscalations
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Settings className="h-5 w-5" />
            CRM Settings
          </DialogTitle>
          <DialogDescription>Configure escalation and pipeline settings</DialogDescription>
        </DialogHeader>
        <div className="space-y-6 mt-4">
          <div className="space-y-4">
            <h3 className="font-semibold flex items-center gap-2">
              <AlertCircle className="h-4 w-4 text-amber-600" />
              Escalation Settings
            </h3>
            <div className="space-y-3 p-4 bg-slate-50 rounded-lg">
              <div className="flex items-center justify-between">
                <Label>Enable Auto-Escalation</Label>
                <Switch 
                  checked={escalationForm.is_active}
                  onCheckedChange={(checked) => setEscalationForm({...escalationForm, is_active: checked})}
                />
              </div>
              <div className="space-y-2">
                <Label>Days without follow-up before escalation</Label>
                <Input 
                  type="number"
                  value={escalationForm.days_before_escalation}
                  onChange={(e) => setEscalationForm({...escalationForm, days_before_escalation: parseInt(e.target.value) || 3})}
                  min={1}
                  max={30}
                />
              </div>
              <div className="flex items-center justify-between">
                <Label>Send Email Notifications</Label>
                <Switch 
                  checked={escalationForm.send_email}
                  onCheckedChange={(checked) => setEscalationForm({...escalationForm, send_email: checked})}
                />
              </div>
              <div className="flex items-center justify-between">
                <Label>Send In-App Notifications</Label>
                <Switch 
                  checked={escalationForm.send_notification}
                  onCheckedChange={(checked) => setEscalationForm({...escalationForm, send_notification: checked})}
                />
              </div>
            </div>
            <Button variant="outline" onClick={onCheckEscalations} className="w-full">
              <AlertTriangle className="h-4 w-4 mr-2" />
              Check Escalations Now
            </Button>
          </div>
        </div>
        <DialogFooter className="mt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onSaveSettings}>Save Settings</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
